module.exports = __webpack_public_path__ + "img/6.1dd2f6ae.jpg";